module.exports = __webpack_public_path__ + "img/Dantam Makeover 06.ba609ee5.jpg";